import React, { useEffect } from "react";
import { StyleSheet } from "react-native";
import { usePostHog } from "posthog-js/react";
import { CONTENT_CONTAINER_PADDING } from "../constants/assessmentConstants";
import { useAppConfig } from "../AppConfigProvider";
import TurnBasedAssessment from "../containers/assessment/turnbasedAssessment/TurnBasedAssessment";
import RealtimeAssessment from "../containers/assessment/realtimeAssessment/RealtimeAssessment";
import { RouteProp, useRoute } from "@react-navigation/native";
import { RootStackParamList } from "../navigation/AppNavigator.web";

function CustomCourseAssessmentStudentView() {
  const posthog = usePostHog();
  const appConfig = useAppConfig();
  const route = useRoute<RouteProp<RootStackParamList, "Custom Course Assessment">>();
  const {
    assessment_id: assessmentId,
    course_id: courseId,
    integration_id: integrationId,
    module_id: moduleId,
  } = route.params;

  const hasTurnBasedAssessments = appConfig?.hasTurnBasedAssessments;

  useEffect(() => {
    posthog?.capture("Assessment Page Visited");
  }, []);

  if (hasTurnBasedAssessments) {
    return <TurnBasedAssessment {...{ assessmentId, courseId, integrationId, moduleId }} />;
  } else {
    return <RealtimeAssessment {...{ assessmentId, courseId, integrationId, moduleId }} />;
  }
}

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
  },
  contentContainer: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    padding: CONTENT_CONTAINER_PADDING,
    backgroundColor: "#E1E5FA",
  },
  liveKitContainer: {
    flex: 1,
    backgroundColor: "#E1E5FA",
  },
  loaderContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default CustomCourseAssessmentStudentView;
